import { Settings } from 'lucide-react';
import type { ComponentPropsWithoutRef } from 'react';
import { cn } from '../lib/utils';

export type SettingsIconProps = ComponentPropsWithoutRef<typeof Settings>;

export function SettingsIcon({ className, ...props }: SettingsIconProps) {
  return <Settings className={cn('size-icon-sm', className)} {...props} />;
}
